/*
 * Modules dependencies
 */

import { Heading } from 'src/components/core/heading';
import { transparentize } from 'src/styles/utils/colors';
import styled from 'styled-components';

/**
 * Export `Step` type.
 */

export type Step = {
  description: string;
  label: string;
  title: string;
};

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  description: string;
  label: string;
  title: string;
};

/**
 * `StyledHeading` component.
 */

const StyledHeading = styled(Heading)`
  background-color: ${transparentize('cyan800', 0.16)};
  border-radius: var(--border-radius-sm);
  height: 100%;
  margin-bottom: 0;
  padding: var(--space-sm);

  > *:not(:last-child) {
    margin-bottom: var(--space-xxs) !important;
  }
`;

/**
 * Export `CardServiceSteps` component.
 */

export function CardServiceSteps(props: Props) {
  return (
    <StyledHeading
      {...props}
      asDescription={'p'}
      asTitle={'h4'}
      descriptionSize={16}
      isDescriptionRaw
      shouldAnimate={false}
      titleSize={22}
      titleTheme={'slate50'}
    />
  );
}
